var _g, _g2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgIconDashboardTransactions(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Livello_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 24 24",
    style: {
      enableBackground: "new 0 0 24 24"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M21.8,16.5l-4.2,3.9l0,0c0,0-0.1,0.1-0.1,0.1c0,0-0.1,0.1-0.1,0.1c0,0,0,0,0,0c-0.1,0-0.2,0-0.3,0 c0,0-0.1,0-0.1,0c-0.1,0-0.2-0.1-0.4-0.2l-0.1,0l-4.2-3.9c-0.3-0.3-0.3-0.8,0-1.1c0.3-0.3,0.8-0.3,1.1,0l3,2.8V6.8 C16.3,6.4,16.6,6,17,6c0.4,0,0.8,0.3,0.8,0.8v11.4l3-2.8c0.3-0.3,0.8-0.3,1.1,0C22.1,15.7,22.1,16.2,21.8,16.5z"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M11.5,8.6c-0.3,0.3-0.8,0.3-1.1,0l-3-2.8v11.4c0,0.4-0.3,0.8-0.8,0.8C6.3,18,6,17.7,6,17.2V5.9L3,8.7 C2.8,8.8,2.6,8.9,2.5,8.9C2.2,8.9,2,8.8,1.9,8.6c-0.3-0.3-0.3-0.8,0-1.1l4.2-3.9l0,0c0.3-0.3,0.7-0.3,1,0l0,0l4.2,3.9 C11.8,7.8,11.8,8.3,11.5,8.6z"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconDashboardTransactions);
export default __webpack_public_path__ + "static/media/icon-dashboard-transactions.126df2b715b225690b0eda877bebacaf.svg";
export { ForwardRef as ReactComponent };